import { toast } from 'react-toastify';
import ApiBase from "./base";
import i18n from "../translations";
import { jsonToQueryString } from '../shared/utils';

export const _DRIVER_TIER_URL = "driver-tier";

export async function getDriverTierList(params) {
    const response = await ApiBase.get(`${_DRIVER_TIER_URL}?${jsonToQueryString(params)}`);
    return response;
}

export async function getDriverTierDetail(id) {
    const response = await ApiBase.get(`${_DRIVER_TIER_URL}/${id}`);
    return response;
}

export async function createDriverTier(params) {
    const response = await ApiBase.post(`${_DRIVER_TIER_URL}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_CREATE_DRIVER_TIER"));
    return response;
}

export async function updateDriverTier(id, params) {
    const response = await ApiBase.patch(`${_DRIVER_TIER_URL}/${id}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_UPDATE_DRIVER_TIER"));
    return response;
}

export async function deleteDriverTier(id) {
    const response = await ApiBase.delete(`${_DRIVER_TIER_URL}/${id}`);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_DELETE_DRIVER_TIER"));
    return response;
}

export async function assignTierToDriver(driverId, tierId, reason) {
    const response = await ApiBase.post(`${_DRIVER_TIER_URL}/assign`, { driverId, tierId, reason });
    if (response.success) toast.success(i18n.t("SUCCESS_TO_ASSIGN_TIER"));
    return response;
}

export async function reorderDriverTiers(tierOrders) {
    const response = await ApiBase.post(`${_DRIVER_TIER_URL}/reorder`, { tierOrders });
    if (response.success) toast.success(i18n.t("SUCCESS_TO_REORDER_TIERS"));
    return response;
}

export async function getDriverTierLogs(params) {
    const response = await ApiBase.get(`${_DRIVER_TIER_URL}/logs?${jsonToQueryString(params)}`);
    return response;
}

export async function getDriverTierProgress(driverId) {
    const response = await ApiBase.get(`${_DRIVER_TIER_URL}/progress/${driverId}`);
    return response;
}



